









import {Vue, Component} from "vue-property-decorator";

@Component
export default class EllipsisScroller extends Vue {

    get wrap(): HTMLElement {
        return this.$refs["wrap"] as HTMLElement;
    }
    hasOverflowed() {
        return this.wrap.scrollWidth > this.wrap.clientWidth;
    }

    scrollText() {
        const wrap = this.wrap;
        const txt = wrap.firstChild as HTMLElement;
        const runCount = Number(txt.style.animationIterationCount) + 1;
        wrap.style.textOverflow = "unset";
        wrap.onclick = () => false;
        txt.addEventListener("animationend", () => {
            wrap.style.textOverflow = "ellipsis";
            txt.style.animationPlayState = "paused";
            this.addOnclick();
        });
        txt.style.animationIterationCount = ""+runCount;
        txt.style.animationPlayState = "running";
    }
    addOnclick() {
        this.wrap.onclick = this.scrollText;
    }

    mounted() {
        if(this.hasOverflowed()) {
            this.addOnclick();
            this.wrap.classList.add("overflowed");
        }
    }
}
